// Generated by scripts/language-coverage.mjs, do not edit by hand.
// Percentage of catalog messages translated, per Lingui catalog id.
export const LANGUAGE_COVERAGE: Record<string, number> = {
  "ar": 71,
  "as": 7,
  "az": 16,
  "be": 29,
  "bg": 21,
  "bn": 19,
  "br": 19,
  "ca": 60,
  "ceb": 6,
  "ckb": 18,
  "cs": 46,
  "da": 21,
  "de": 58,
  "el": 18,
  "en": 100,
  "en-US": 18,
  "es": 71,
  "es-419": 31,
  "et": 26,
  "fa": 18,
  "fi": 51,
  "fil": 18,
  "fr": 71,
  "ga": 14,
  "hi": 17,
  "hr": 17,
  "hu": 41,
  "hy": 22,
  "id": 71,
  "is": 2,
  "it": 70,
  "ja": 53,
  "ko": 22,
  "lb": 17,
  "lt": 18,
  "lv": 18,
  "mk": 4,
  "ms": 17,
  "nb-NO": 51,
  "nl": 58,
  "pl": 54,
  "pt-BR": 71,
  "pt-PT": 61,
  "ro": 22,
  "ru": 71,
  "si": 18,
  "sk": 39,
  "sl": 18,
  "sq": 19,
  "sr": 18,
  "sv": 56,
  "ta": 6,
  "th": 18,
  "tr": 71,
  "uk": 61,
  "ur": 4,
  "vec": 9,
  "vi": 24,
  "zh-Hans": 20,
  "zh-Hant": 22,
};
